/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Lending_DescriptionInputs */



/**
* | output |
* | --- |
* | "Cards lent to friends and cards you're borrowing" |
*
* @param {Nav_Lending_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_lending_description = /** @type {((inputs?: Nav_Lending_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Lending_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verliehene Karten und Karten, die du geliehen hast")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cartes prêtées à vos amis et cartes que vous empruntez")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("借给朋友的卡和你借来的卡")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("借給朋友的卡，以及你向別人借的卡")
	if (locale === "ko") return /** @type {LocalizedString} */ ("친구에게 빌려준 카드와 빌려온 카드")
	return /** @type {LocalizedString} */ ("Cards lent to friends and cards you're borrowing")
});